export const displayFormatDate = {
  de_DE: 'DD.MM.YYYY',
  'de-DE': 'DD.MM.YYYY',
  de: 'DD.MM.YYYY',
  at: 'DD.MM.YYYY',
  'de-AT': 'DD.MM.YYYY',
  de_AT: 'DD.MM.YYYY',
  'de-CH': 'DD.MM.YYYY',
  de_CH: 'DD.MM.YYYY',
  nl_NL: 'DD.MM.YYYY',
  'nl-NL': 'DD.MM.YYYY',
  nl: 'DD.MM.YYYY'
};

export const displayFormatDateTime = {
  de_DE: 'DD.MM.YYYY HH:mm',
  'de-DE': 'DD.MM.YYYY HH:mm',
  de: 'DD.MM.YYYY HH:mm',
  at: 'DD.MM.YYYY HH:mm',
  'de-AT': 'DD.MM.YYYY HH:mm',
  de_AT: 'DD.MM.YYYY HH:mm',
  'de-CH': 'DD.MM.YYYY HH:mm',
  de_CH: 'DD.MM.YYYY HH:mm',
  nl_NL: 'DD.MM.YYYY HH:mm',
  'nl-NL': 'DD.MM.YYYY HH:mm',
  nl: 'DD.MM.YYYY HH:mm'
};
